import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiErrors } from '@nx-customer-apps/shared/enums';

@Injectable()
export class NoNullInterceptor implements HttpInterceptor {
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone();

        if (['PATCH', 'PUT', 'POST'].includes(request.method) && request.url.includes('planning-projects')) {
            request = request.clone({ body: this.assertNoNulls(request.body, true) });
        }

        return next.handle(request);
    }

    private assertNoNulls(payload: unknown, stripNulls = false): unknown {
        return this.walkAndValidate(payload, 'payload', stripNulls);
    }

    private walkAndValidate(value: unknown, path: string, stripNulls: boolean): unknown {
        if (value === null) {
            console.warn(`PATCH payload contains null at ${path}, stripping it from payload`);
            if (stripNulls) {
                return undefined;
            }
            throw new HttpErrorResponse({
                status: 422,
                statusText: 'Unprocessable Entity',
                error: {
                    name: 'NoNullInterceptor',
                    status: 422,
                    key: ApiErrors.NullValue,
                    message: `PATCH payload contains null at ${path}`,
                    errors: []
                }
            });
        }

        if (Array.isArray(value)) {
            return value.map((item, index) => this.walkAndValidate(item, `${path}[${index}]`, stripNulls));
        }

        if (this.isPlainObject(value)) {
            const result: Record<string, unknown> = { ...value };
            Object.keys(result).forEach(key => {
                const nextValue = result[key];
                result[key] = this.walkAndValidate(nextValue, `${path}.${key}`, stripNulls);
            });
            return result;
        }

        return value;
    }

    private isPlainObject(value: unknown): value is Record<string, unknown> {
        if (!value || typeof value !== 'object') {
            return false;
        }

        return Object.prototype.toString.call(value) === '[object Object]';
    }
}
